import type { PageWidthHint } from "@/app/lazyPage";
import { PageLoading } from "@/shared/systemScreens/PageLoading";
import { pageFrameClass } from "./pageFrame";

/**
 * The LOADING box, placed. A zero-height strip at the top of `<main>` (CSS:
 * `page-pending-anchor`) holding the box in the frame a page of the coming
 * width draws itself in, so it starts at the page's own start edge and top
 * with the same padding and scrollbar, and takes no layout of its own — the
 * page it stands in for stays in the flow underneath, dimmed.
 */
export function PageLoadingAnchor({ width }: { width: PageWidthHint }) {
  return (
    <div data-ui="page-pending-anchor">
      <div className={pageFrameClass(width)}>
        <PageLoading />
      </div>
    </div>
  );
}
